import { defaultFillColor, defaultZoneFillColor, zoneColors } from './displayModeHelper';

/* eslint-disable no-bitwise */
/**
 * If zoneColors has mapping for zoneName, then display color based on mapping
 * Else convert zoneName to a hex color value by hashing
 */
export const stringToColor = (zoneName: string, opacity = 1): string => {
  // if zoneColors has mapping for zoneName, then return macthed color
  if (zoneColors[zoneName]) {
    return zoneColors[zoneName];
  }

  let hash = 0;

  // Define rgb color array
  const color = [0, 0, 0];

  for (let i = 0; i < zoneName.length; ) {
    hash = zoneName.charCodeAt(i) + ((hash << 5) - hash);
    i += 1;
  }

  for (let i = 0; i < 3; ) {
    const value = (hash >> (i * 8)) & 0xff;
    color[i] = value;
    i += 1;
  }

  // Format the result as rgba
  return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${opacity})`;
};

/**
 * return color based on zoneName and fixtureId
 * if zoneColors has mapping for zoneName, then display color based on mapping
 * else if it's agile fixture and zoneName is not empty, generate color ramdonly base on zoneName
 * else if it's agile, display defaultZoneFillColor
 * for non-agile fixtures, display defaultFillColor
 */
const getColorForText = (zoneName: string, isAgile: boolean): string => {
  if (isAgile) {
    if (zoneName) {
      return stringToColor(zoneName);
    }
    return defaultZoneFillColor;
  }
  return defaultFillColor;
};

export default getColorForText;
